import './App.css';
import React, { useEffect } from 'react';
import HomePage from './page/HomePage/HomePage';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './i18n/i18n';
import './styles/animations.css';
import { useScrollAnimation } from './hooks/useScrollAnimation';
import Dashboard from './page/TournamentPages/Dashboard/Dashboard';
import Admin from './page/Admin/Admin';
import useWalletStore from './hooks/useStore';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const App = () => {
  useScrollAnimation();
  
  useEffect(() => {
    useWalletStore.getState().initWallet();
  }, []);
  
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/tetris" element={<HomePage scrollToTetris={true} />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
      <ToastContainer />
    </BrowserRouter>
  );
};

export default App;
